// helpers

export const getAttitude = MBTI => MBTI[0]
export const getPreference = MBTI => MBTI[3]
export const getFunctions = MBTI => MBTI[1] + MBTI[2]
export const flipAttitude = MBTI => flip(getAttitude(MBTI))

export const flip = F => {
  F = F.toUpperCase()
  return {
    I: "E",
    E: "I",
    N: "S",
    S: "N",
    F: "T",
    T: "F",
    J: "P",
    P: "J"
  }[F]
}

export const flipFuncAttitude = F => `${F[0]}${flip(F[1]).toLowerCase()}`

export const mapFunction = (MBTI, flipAttitude = false) => {
  // function, function, attitude
  MBTI = MBTI.toUpperCase()
  const attitude = (flipAttitude
    ? flip(getAttitude(MBTI))
    : getAttitude(MBTI)
  ).toLowerCase()
  const preference = getPreference(MBTI)
  const map = {
    Pe: MBTI[1],
    Pi: MBTI[2],
    Je: MBTI[2],
    Ji: MBTI[1]
  }
  const func = map[`${preference}${attitude}`]
  return `${func}${attitude}`
}

export const getAllFunctions = () => [
  "Se",
  "Si",
  "Ne",
  "Ni",
  "Te",
  "Ti",
  "Fe",
  "Fi"
]

export const getAbsentFunctions = MBTI => {
  const all = getAllFunctions()
  const primary = [
    getDominateFunction(MBTI),
    getAuxililaryFunction(MBTI),
    getTertiaryFunction(MBTI),
    getInferiorFunction(MBTI)
  ]
  return all.filter(f => primary.indexOf(f) < 0)
}

export const isValidMBTI = MBTI =>
  ":INFP:ESFJ:ESFP:ISFJ:ISFP:ESTJ:ESTP:ISTJ:ISTP:INTJ:INFJ:ENTJ:ENTP:ENFJ:INTP:ENFP:".indexOf(
    `:${MBTI.toUpperCase()}:`
  ) > -1

export const getDominateFunction = MBTI => mapFunction(MBTI)
export const getAuxililaryFunction = MBTI => mapFunction(MBTI, true)
export const getTertiaryFunction = MBTI =>
  `${flip(getAuxililaryFunction(MBTI)[0])}${getAttitude(MBTI).toLowerCase()}`
export const getInferiorFunction = MBTI =>
  `${flip(getDominateFunction(MBTI)[0])}${flip(
    getAttitude(MBTI)
  ).toLowerCase()}`

// export const functionKeywords = {
//   Ne: ["creative", "visionary"],
//   Ti: ["analytical", "objective"],
//   Ni: ["strategic", "architecting"],
//   Te: ["methodical", "rational"],
//   Se: ["scrupulous", "present"],
//   Fi: ["empathetic", "sensitive"], // poetic
//   Si: ["pragmatic", "procedural"],
//   Fe: ["nurturing", "attentive"],
// }
export const functionKeywords = {
  Ne: ["exploratory", "optimistic"],
  Ti: ["accurate", "focused"],
  Ni: ["insightful", "objective"],
  Te: ["effective", "organized"],
  Se: ["kinesthetic", "present"],
  Fi: ["empathetic", "authentic"], // poetic
  Si: ["historical", "traditional"],
  Fe: ["nurturing", "attentive"]
}

export const definitions = {
  effective: "Makes things happen.",
  organized: "manages resources and people to accomplish goals",
  nurturing: "promotes harmony by understanding the needs of others",
  attentive: "pays attention to cultural and social contracts",
  empathetic: "recognizes how events impact others from experience",
  authentic: "holds and acts on strong personal convictions",
  accurate: "quickly analyses and understands frameworks to make choices",
  focused:
    "hones in on the objective state of something with often blunt honesty and obsession",
  historical: "recalls events as they happen unemotionally",
  traditional: "prefers order, procedure and tradition as a way of operating",
  kinesthetic: "learns through activity and action",
  present:
    "understands the world realistically through their senses in the moment",
  insightful:
    "uses a deep understanding patterns and systems to see the future",
  objective: "open to all perspectives",
  exploratory: "recognizes and explores patterns in the outside world",
  optimistic:
    "sees new possibilities everywhere and in a generally positive light"
}

const getFuncOrder = func => Object.keys(functionKeywords).indexOf(func)

export const getTraits = MBTI => {
  const weightTraitsForFunc = (func, s, e) => {
    let ks = functionKeywords[func]
    const l = ks.length
    return ks.reduce((list, name, i) => {
      const p = (l - i) / l
      const weight = s + (e - s) * p
      const order = getFuncOrder(func) + p
      const definition = definitions[name]
      list.push({ name, weight, func, order, definition })
      return list
    }, [])
  }

  const d = getDominateFunction(MBTI)
  const df = flipFuncAttitude(d)

  let funcs = [
    { f: getDominateFunction(MBTI), r: [0.9, 1] },
    { f: getAuxililaryFunction(MBTI), r: [0.7, 0.9] },
    { f: getTertiaryFunction(MBTI), r: [0.25, 0.35] },
    { f: getInferiorFunction(MBTI), r: [0.15, 0.25] }
  ]

  // add in ancillary funcs diminisiond slightly
  funcs = funcs.reduce((funcs, func) => {
    return funcs.concat({
      f: flipFuncAttitude(func.f),
      r: [Math.max(func.r[0] - 0.3, 0.2), Math.max(func.r[1] - 0.3, 0.2)] //  [0.1, 0.2] //[func.r[0] - 0.1, func.r[1] - 0.1]
    })
  }, funcs)

  return funcs
    .reduce((list, func) => {
      return list.concat(weightTraitsForFunc(func.f, func.r[0], func.r[1]))
    }, [])
    .sort((a, b) => (a.order > b.order ? 1 : -1))
}



// WEBPACK FOOTER //
// ./src/store/functions.js